import apiRequest from '@/apiRequest'
import { AxiosResponse } from 'axios'
import ApiRequestPaths from '@/apiRequestPaths'

export interface SocialStreamConfig {
  socialStreamId: string | null,
  instagramHandle: string,
  includedHashTag: string,
  influencerSubpage: string,
  influencerSubpageHeader: string,
  influencerProfileImage: string,
  filterAvailable: boolean,
  clickThrough: string | null,
}

export interface SocialStreamConfigResponse {
  socialStreamId: string | null,
  instagramHandle: string,
  includedHashTag: string,
  influencerSubpage: string,
  influencerSubpageHeader: string,
  influencerProfileImage: string,
  filterAvailable: boolean,
  clickThrough: string | null,
  productsCatalogId: string | null,
  productsCatalogName: string | null,
  instagramPostsCatalogId: string | null,
  instagramPostsCatalogName: string | null,
}

export interface SocialStreamConfigs {
  configs: Array<SocialStreamConfigResponse>,
}

export interface SocialStreamCatalogs {
    productsCatalogId: string,
    productsCatalogName: string,
    instagramPostsCatalogId: string,
    instagramPostsCatalogName: string,
}

export class SocialStreamApiRequest {
  static async getSocialStreamConfigs(): Promise<AxiosResponse<SocialStreamConfigs>> {
    return apiRequest.get<SocialStreamConfigs>(ApiRequestPaths.GET_SOCIAL_STREAM_CONFIGS)
  }

  static async getSocialStreamConfig(configId: string): Promise<AxiosResponse<SocialStreamConfigResponse>> {
    return apiRequest.get<SocialStreamConfigResponse>(ApiRequestPaths.GET_SOCIAL_STREAM_CONFIG.replace('{configId}', configId))
  }

  static storeSocialStreamConfig(socialStreamConfig: SocialStreamConfig) {
    return apiRequest.post<SocialStreamConfig>(ApiRequestPaths.STORE_SOCIAL_STREAM_CONFIG, socialStreamConfig)
  }

  static async getSocialStreamCatalogs(configId: string): Promise<AxiosResponse<SocialStreamCatalogs>> {
    return apiRequest.get<SocialStreamCatalogs>(ApiRequestPaths.SOCIAL_STREAM_CATALOGS.replace('{configId}', configId))
  }

  static storeSocialStreamCatalogs(configId: string, socialStreamCatalogs: SocialStreamCatalogs) {
    return apiRequest.post<SocialStreamCatalogs>(ApiRequestPaths.SOCIAL_STREAM_CATALOGS.replace('{configId}', configId), socialStreamCatalogs)
  }
}
